
export default {
  ['SET_SOCKET_CONNECTION'](state, payload) {
    state.socketConnection = payload;
  }
}
